// Helpers para links WhatsApp
// Converte um número em formato internacional (com/sem +, com/sem espaços) numa URL wa.me
// Ex: waHref("+351 912 345 678") -> "https://wa.me/351912345678"
// Ex: waHref("+351 912 345 678", "Olá!") -> "https://wa.me/351912345678?text=Ol%C3%A1!"
export function waHref(raw, message = "") {
  if (!raw) return "";
  const digits = String(raw).replace(/\D+/g, "");
  if (!digits) return "";
  const base = `https://wa.me/${digits}`;
  const msg = (message || "").trim();
  if (!msg) return base;
  return `${base}?text=${encodeURIComponent(msg)}`;
}

// Formata para display, preservando o formato inserido pelo utilizador
export function waDisplay(raw) {
  return (raw || "").trim();
}
